import React from "react";

const PreviewLightHeadComponent = ({ PH, closeLightHeadPreviewModel, tooltipData }) => {
  let lightbar = tooltipData?.replace(/<br \/>/gi, "<br>");
  lightbar = lightbar?.replace(/<br\/>/gi, "<br>");
  lightbar = lightbar?.split("<br>");
  return (
    <>
      <div id="previewLightbar-modal" className="m-auto">
        <div className="modal-dialog m-0">
          <div className="modal-content">
            <div className="d-flex align-items-center">
              <h2 className="modal-title text-white text-uppercase mt-0">PREVIEW</h2>
              <div className="close-icon text-end ms-auto">
                <button type="button" className="close" data-dismiss="modal" onClick={closeLightHeadPreviewModel}>
                  <span aria-hidden="true">
                    <i className="fa fa-times text-red" />
                  </span>
                </button>
              </div>
            </div>
            <div class="text-white mt-10">
              {lightbar?.map((data) => (
                <div className="text-white mt-10">{data}</div>
              ))}
            </div>
            <div className="canvas-position text-center" style={{ height: `${PH}px` }}>
              <svg width="862" height="180" viewBox="0 0 862 231" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="32" y="22" width="150" height="41" rx="10" fill="#0000F5" />
                <rect x="681" y="22" width="150" height="41" rx="10" fill="#D53D35" />
                <rect x="32" y="169" width="150" height="41" rx="10" fill="#D53D35" />
                <rect x="681" y="169" width="150" height="41" rx="10" fill="#0000F5" />
                <path
                  d="M186 32C186 26.4772 190.477 22 196 22H287C292.523 22 297 26.4772 297 32V42.5H186V32Z"
                  fill="#0000F5"
                />
                <path
                  d="M297 53C297 58.5228 292.523 63 287 63L196 63C190.477 63 186 58.5228 186 53V42.5L297 42.5V53Z"
                  fill="#F5C242"
                />
                <path
                  d="M186 179C186 173.477 190.477 169 196 169H223V210H196C190.477 210 186 205.523 186 200V179Z"
                  fill="#0000F5"
                />
                <path d="M259.5 169.5V209.5H223.5V169.5H259.5Z" fill="white" stroke="#C9C9C9" />
                <path
                  d="M297 200C297 205.523 292.523 210 287 210H260V169H287C292.523 169 297 173.477 297 179V200Z"
                  fill="#5BC049"
                />
                <path
                  d="M32 78C32 72.4772 36.4772 68 42 68H52C57.5228 68 62 72.4772 62 78V115.5H32V78Z"
                  fill="#D53D35"
                />
                <path
                  d="M62 152.5C62 158.023 57.5228 162.5 52 162.5H42C36.4772 162.5 32 158.023 32 152.5L32 115H62L62 152.5Z"
                  fill="#0000F5"
                />
                <path
                  d="M801 78C801 72.4772 805.477 68 811 68H821C826.523 68 831 72.4772 831 78V115.5H801V78Z"
                  fill="#D53D35"
                />
                <path
                  d="M831 152.5C831 158.023 826.523 162.5 821 162.5H811C805.477 162.5 801 158.023 801 152.5V115H831V152.5Z"
                  fill="#0000F5"
                />
                <path
                  d="M303 32C303 26.4772 307.477 22 313 22H404C409.523 22 414 26.4772 414 32V42.5H303V32Z"
                  fill="#0000F5"
                />
                <path
                  d="M414 53C414 58.5228 409.523 63 404 63L313 63C307.477 63 303 58.5228 303 53V42.5L414 42.5V53Z"
                  fill="#F5C242"
                />
                <path
                  d="M449 32C449 26.4772 453.477 22 459 22H550C555.523 22 560 26.4772 560 32V42.5H449V32Z"
                  fill="#0000F5"
                />
                <path
                  d="M550 62.5L459 62.5C453.753 62.5 449.5 58.2467 449.5 53V43L559.5 43V53C559.5 58.2467 555.247 62.5 550 62.5Z"
                  fill="white"
                  stroke="#C9C9C9"
                />
                <path
                  d="M560 200C560 205.523 555.523 210 550 210H459C453.477 210 449 205.523 449 200V189.5H560V200Z"
                  fill="#0000F5"
                />
                <path
                  d="M449 179C449 173.477 453.477 169 459 169L550 169C555.523 169 560 173.477 560 179V189.5L449 189.5V179Z"
                  fill="#F5C242"
                />
                <path
                  d="M565 32C565 26.4772 569.477 22 575 22H666C671.523 22 676 26.4772 676 32V42.5H565V32Z"
                  fill="#0000F5"
                />
                <path
                  d="M666 62.5L575 62.5C569.753 62.5 565.5 58.2467 565.5 53V43L675.5 43V53C675.5 58.2467 671.247 62.5 666 62.5Z"
                  fill="white"
                  stroke="#C9C9C9"
                />
                <path
                  d="M676 200C676 205.523 671.523 210 666 210H575C569.477 210 565 205.523 565 200V189.5H676V200Z"
                  fill="#0000F5"
                />
                <path
                  d="M565 179C565 173.477 569.477 169 575 169L666 169C671.523 169 676 173.477 676 179V189.5L565 189.5V179Z"
                  fill="#F5C242"
                />
                <path
                  d="M303 179C303 173.477 307.477 169 313 169H340V210H313C307.477 210 303 205.523 303 200V179Z"
                  fill="#0000F5"
                />
                <path d="M376.5 169.5V209.5H340.5V169.5H376.5Z" fill="white" stroke="#C9C9C9" />
                <path
                  d="M414 200C414 205.523 409.523 210 404 210H377V169H404C409.523 169 414 173.477 414 179V200Z"
                  fill="#5BC049"
                />
              </svg>
            </div>
            <div className="table-responsive" style={{ height: "calc(100vh - 432px)" }}>
              <table className="table el-header table-bordered align-middle table-dark">
                <thead>
                  <tr>
                    <th>Lighthead Position</th>
                    <th>Source</th>
                    <th>Position</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { pos: 2, source: "F5LBA - BLUE", location: "FRONT" },
                    { pos: "", source: "F5LBA - AMBER", location: "FRONT" },

                    { pos: 3, source: "F5LBA - BLUE", location: "FRONT" },
                    { pos: "", source: "F5LBA - AMBER", location: "FRONT" },

                    { pos: 4, source: "F5RBW - BLUE", location: "FRONT" },
                    { pos: "", source: "F5RBW - WHITE", location: "FRONT" },

                    { pos: 5, source: "F5RBW - BLUE", location: "FRONT" },
                    { pos: "", source: "F5RBW - WHITE", location: "FRONT" },

                    { pos: 7, source: "F5ERB - RED", location: "RIGHT" },
                    { pos: "", source: "F5ERB - BLUE", location: "RIGHT" },

                    { pos: 9, source: "F5RBA - BLUE", location: "REAR" },
                    { pos: "", source: "F5RBA - AMBER", location: "REAR" },

                    { pos: 10, source: "F5RBA - BLUE", location: "REAR" },
                    { pos: "", source: "F5RBA - AMBER", location: "REAR" },

                    { pos: 11, source: "F5LBWG - BLUE", location: "REAR" },
                    { pos: "", source: "F5LBWG - WHITE", location: "REAR" },
                    { pos: "", source: "F5LBWG - GREEN", location: "REAR" },

                    { pos: 12, source: "F5LBWG - BLUE", location: "REAR" },
                    { pos: "", source: "F5LBWG - WHITE", location: "REAR" },
                    { pos: "", source: "F5LBWG - GREEN", location: "REAR" },

                    { pos: 14, source: "F5ERB - RED", location: "LEFT" },
                    { pos: "", source: "F5ERB - BLUE", location: "LEFT" },
                  ].map((row) => (
                    <tr key={`${row.pos}-${row.source}-${row.location}`}>
                      <td>{row.pos}</td>
                      <td>{row.source}</td>
                      <td>{row.location}</td>
                      <td>
                        <input type="checkbox" className="form-check-input" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewLightHeadComponent;
